import ebayLogo    from '@/assets/images/logos/ebay-mini.svg'
import shopifyLogo from '@/assets/images/logos/shopify-mini.svg'
import whatnotLogo from '@/assets/images/logos/whatnot-yellow-mini.svg'
import collxLogo   from '@/assets/images/logos/collx-mini.svg'

// Single source of truth for marketplace metadata (key + display label +
// mini-logo asset). Replaces the inline maps that lived in:
//   • src/views/Orders/index.vue                              — stat-strip
//   • src/views/Orders/TableComponents/OrdersMarketplaceCell  — table cell
//   • src/views/SalePickList/index.vue                        — channel strip
//   • any future per-marketplace pill / cell / strip
//
// API value (lowercase) is the key; rendering layer reads label + logo.

export const MARKETPLACES = Object.freeze({
  ebay:    { value: 'ebay',    label: 'eBay',    logo: ebayLogo    },
  shopify: { value: 'shopify', label: 'Shopify', logo: shopifyLogo },
  whatnot: { value: 'whatnot', label: 'Whatnot', logo: whatnotLogo },
  collx:   { value: 'collx',   label: 'CollX',   logo: collxLogo   },
  // `other` is a valid API marketplace value but has no canonical logo; the
  // consumer renders a generic icon (or hides the image) when key === 'other'.
  other:   { value: 'other',   label: 'Other',   logo: null        },
})

export const MARKETPLACE_VALUES = Object.keys(MARKETPLACES)

// User-pickable marketplaces for the filter dropdowns, in popularity order
// (eBay, CollX, Whatnot, Shopify). SINGLE SOURCE shared by BOTH the Orders and
// Sale Pick List marketplace filters — reorder here to change both. Excludes
// `other` (catch-all, not user-pickable).
export const FILTER_MARKETPLACES = Object.freeze(
  ['ebay', 'collx', 'whatnot', 'shopify'].map(value => ({ value, label: MARKETPLACES[value].label })),
)

export const FILTER_MARKETPLACE_VALUES = FILTER_MARKETPLACES.map(m => m.value)

// Convenience accessor that always returns an entry (falls back for unknown
// keys instead of letting the caller render `undefined`).
export const getMarketplace = (key) => {
  const k = String(key ?? '').toLowerCase()
  return MARKETPLACES[k] ?? { value: k, label: key ?? '—', logo: null }
}
